import { Buffer } from "buffer";

export const calculateBytesLength = (tokenName: string, encoding: BufferEncoding = "utf-8") => {
  return Buffer.from(tokenName, encoding).length;
};
